<div class="modal-view activity-details" c-toggle="showView">
    <div c-activity-queue activities="activities"></div>
</div>